const counter: Record<string, number> = {};

export function useUID(prefix = "id") {
  if (!counter[prefix]) counter[prefix] = 0;
  return `${prefix}-${++counter[prefix]}`;
}
